import React from "react";
import { AfterLoginTemplate } from "src/components/AfterLoginTemplate";
import { ChartJsExamples } from "./ChartJsExamples";

interface IProps {}

export class ExamplesChartsJSPage extends React.PureComponent<IProps> {
  public render() {
    return (
      <AfterLoginTemplate>
        <div className="container">
          <div
            style={{
              marginTop: "15px",
            }}
          >
            <p style={{ marginBottom: 40 }}>
              Examples of Peekdata React SDK for Reporting and Data API and the
              Chart.js library. The SDK allows to form a request, get data and
              use it to visualize the data. Find out more at our{" "}
              <a
                href="https://peekdata.io/developers/index.html#/js-sdk/"
                target="_blank"
              >
                Developer's Guide
              </a>
              .
            </p>
          </div>

          <ChartJsExamples />
        </div>
      </AfterLoginTemplate>
    );
  }
}
